import * as React from 'react';
import DriveItemDeleteButton from '../../../containers/DriveItem/DeleteButton';
import DriveItemDownloadButton from '../../../containers/DriveItem/DownloadButton';
import { ActionButtonStyle } from '../../../utils/driveItem';
import { ButtonContainer } from '../styles';

interface ActionButtonsProps {
	hasItemsToDownload: boolean;
	hasDownloadedItems: boolean;
}

const ActionButtons = (props: ActionButtonsProps) => {
	const { hasDownloadedItems } = props;

	return (
		<ButtonContainer>
			{hasDownloadedItems &&
				<DriveItemDeleteButton style={ActionButtonStyle.ParametersPage} />
			}
			<DriveItemDownloadButton
				style={ActionButtonStyle.ParametersPage}
			/>
		</ButtonContainer>
	);
};

export default ActionButtons;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/ActionButtons/index.tsx